import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  Axios, { formAuthHeaders }  from "../../utils/axios"

export const reqToSendInquiry = createAsyncThunk("inquiry/reqToSendInquiry", async (data,{rejectWithValue}) => {
  try{
      const response = await Axios.post(`/api/inquiries`,data,formAuthHeaders());
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const reqToSendEmail = createAsyncThunk("inquiry/reqToSendEmail", async ({rejectWithValue}) => {
    try{
      const response = await Axios.post(`/api/send-email`);
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const reqToSendEmailToCustomer = createAsyncThunk("inquiry/reqToSendEmailToCustomer", async ({rejectWithValue}) => {
    try{
      const response = await Axios.post(`/api/send-email-to-customer`);
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});



const inquirySlice = createSlice({
    name:"inquiry",
    initialState:{
        error:null,
        isLoading:false,
        inquiries:{},
        sendEmail:{},
        sendEmailToCustomer:{}
    },
    reducer:{},
    extraReducers:(builder)=>{
        builder
        // Req to Send Inquiry
        .addCase(reqToSendInquiry.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(reqToSendInquiry.fulfilled, (state,action) => {
            state.isLoading = false;
            state.inquiries = action.payload;
        })
        .addCase(reqToSendInquiry.rejected, (state,action) => {
            state.isLoading = false;
            state.error = action.payload
        })
        // Req to Send Email
        .addCase(reqToSendEmail.fulfilled, (state,action) => {
            state.isLoading = false;
            state.sendEmail = action.payload
        })
        // Req to Send Email to Customer
        .addCase(reqToSendEmailToCustomer.fulfilled, (state,action) => {
            state.isLoading = false;
            state.sendEmailToCustomer = action.payload
        })
    }
})

export default inquirySlice.reducer;